export default "__VITE_ASSET__Dz815bUL__"